export default {
  zh: {
    pageTitle: '扭蛋机',
    jackPotRankTitle: '查看大奖排行',
    jackPotPro: '当前大奖概率',
    rank: '排行',
    rule: '规则',
    shop: '商店',
    bigPrizeRule: '大奖规则',
    poolL: '普通',
    poolH: '高级',
    goodsList: '奖励列表',
    record: '抽奖记录',
    ten: '10次',
    fifty: '50次',
    goods: '奖励',
    count: '数量',
    fra: '碎片',
    isExchange: '确定要兑换该礼物吗?',
    yes: '确定',
    no: '取消',
    rwDesc: '您获得下列奖励',
    congratulate: '中奖啦!',
    seeMore: '查看更多',
    noMore: '没有更多记录了',

    exRc: '兑换记录',
    cjRc: '抽奖记录',
    nw: '网络繁忙',
    noG: '金币不足',
    noF: '碎片不足',
    exSuc: '兑换成功',
    gf: '礼物',

    ruleTxt: `
    你获得的碎片可以在商店兑换礼物。<br/><br/>
    普通<br/>
    10次：需要消耗100金币<br/>
    50次：需要消耗500金币<br/>
    高级<br/>
    10次：需要消耗1000金币<br/>
    50次：需要消耗5000金币<br/>
    `,
    prizeRuleTxt: `
    1.当概率成功增加1%后，你再次抽奖，那么，你就会有机会获得大奖。<br/>
    2.当所有用户花费的金币达到一个总值，那么概率将会增加1% <br/>
    3.大奖开始的概率为 0 % <br/>
    4.大奖礼物会定期更新
    `
  },
  en: {
    pageTitle: 'Gashapon',
    jackPotRankTitle: 'JackPot Ranking',
    jackPotPro: 'Jackpot<br/>probability',
    rank: 'Ranking',
    rule: 'Rules',
    shop: 'Shop',
    bigPrizeRule: 'JackPot Rules',
    poolL: 'Normal',
    poolH: 'Deluxe',
    goodsList: 'Reward List',
    record: 'Record',
    ten: '10 times',
    fifty: '50 times',
    goods: 'Reward',
    count: 'Total',
    fra: 'Fragment',
    isExchange: 'Are you sure you want to exchange this gift?',
    yes: 'Yes',
    no: 'Cancel',
    rwDesc: 'You have obtained the following rewards',
    congratulate: 'Congratulations!',
    seeMore: 'More',
    noMore: 'No more records',

    exRc: 'Exchange Record',
    cjRc: 'Draw Record',
    nw: 'Network is busy',
    noG: 'Gold shortage',
    noF: 'Not enough fragments',
    exSuc: 'Successful Exchange',
    gf: 'Gift',

    ruleTxt: `
    1. The shards you get can be exchanged for gifts in the store.<br/><br/>
    Normal<br/>
    10 times: need to consume 100 gold coins<br/>
    50 times: need to consume 500 gold coins<br/>
    Deluxe<br/>
    10 times: need to consume 1000 gold coins<br/>
    50 times: need to consume 5000 gold coins<br/>
    `,
    prizeRuleTxt: `
    1. When the probability is successfully increased by 1%, you draw again, then you will get a big prize possibly.<br/>
    2. When the gold coins spent by all users reach a total value, the probability will increase by 1%<br/>
    3. The probability of jackpot start is 0 % <br/>
    4. big prize gifts will be updated regularly
    `
  },
  ar: {
    pageTitle: 'Gashapon',
    jackPotRankTitle: 'الترتيب',
    jackPotPro: 'احتمال',
    rank: 'الترتيب',
    rule: 'القواعد',
    shop: 'متجر',
    bigPrizeRule: 'القواعد الفوز بالجائزة السوبر',
    poolL: 'كلاسيكي',
    poolH: 'المتقدم',
    goodsList: 'قائمة المكافآت',
    record: 'سجل',
    ten: '10 مرة',
    fifty: '50 مرة',
    goods: 'المكافأة',
    count: 'عدد',
    fra: 'قطعه',
    isExchange: 'هل أنت متأكد أنك تريد استرداد هذه الهدية',
    yes: 'أكد',
    no: 'إلغاء',
    rwDesc: 'لقد تلقيت المكافآت التالية',
    congratulate: 'مبروك ، لقد تمت مكافأتك',
    seeMore: 'شاهد المزيد',
    noMore: 'لا مزيد من السجلات',

    exRc: 'سجل السحب',
    cjRc: 'سجل التحويل',
    nw: 'الشبكة مشغولة',
    noG: 'الذهبية غير كافية',
    noF: 'قطعه غير كافية',
    exSuc: 'تم التحويل بنجاح',
    gf: 'هدية',

    ruleTxt: `
    يمكن استبدال القطع التي تحصل عليها مقابل هدايا في المتجر <br/><br/>
    كلاسيكي  <br/>
    10 مرات: تحتاج إلى أستخدم 100 ذهبية <br/>
    50 مرة: تحتاج إلى استخدم 500 ذهبية <br/>
    المتقدم <br/>
    10 مرات: تحتاج إلى استخدم 1000 ذهبية <br/>
    50 مرة: تحتاج إلى استخدم 5000 ذهبية  <br/>
    `,
    prizeRuleTxt: `
    1 - عند احتمال زيادة بنسبة 1 ٪ ، يمكنك السحب مرة أخرى ، ثم فربما الفوز بالجائزة السوبر  <br/>
    2 - احتمال زيادة بنسبة 1 ٪ عند جميع المستخدمين تنفق مبلغ إجمالي من الذهب . <br/>
    3 - احتمال بدء الفوز بالجائزة الكبرى هو 0٪ <br/>
    4 - جوائز الهدايا السوبر سيتم تقديمها بانتظام 
    `
  },
  pt: {
    pageTitle: 'Gashapon',
    jackPotRankTitle: 'Ranking do JackPot',
    jackPotPro: 'Probabilidade do Jackpot',
    rank: 'Ranking',
    rule: 'Regras',
    shop: 'Loja',
    bigPrizeRule: 'Regras do Jackpot',
    poolL: 'Normal',
    poolH: 'Deluxe',
    goodsList: 'Lista de Recompensas',
    record: 'Registro',
    ten: '10 vezes',
    fifty: '50 vezes',
    goods: 'Recompensa',
    count: 'Total',
    fra: 'Fragmento',
    isExchange: 'Tem certeza de que deseja trocar este presente?',
    yes: 'Sim',
    no: 'Cancelar',
    rwDesc: 'Você obteve as seguintes recompensas',
    congratulate: 'Parabéns!',
    seeMore: 'Mais',
    noMore: 'Sem mais registros',
    exRc: 'Registro de Troca',
    cjRc: 'Registro de Sorteio',
    nw: 'A rede está ocupada',
    noG: 'Falta ouro',
    noF: 'Fragmentos insuficientes',
    exSuc: 'Troca bem-sucedida',
    gf: 'Presente',
    ruleTxt:
      '1. Os fragmentos que você obtém podem ser trocados por presentes na loja.<br/><br/> Normal<br/> 10 vezes: precisa consumir 100 moedas de ouro<br/> 50 vezes: precisa consumir 500 moedas de ouro<br/> Deluxe<br/> 10 vezes: precisa consumir 1000 moedas de ouro<br/> 50 vezes: precisa consumir 5000 moedas de ouro<br/>',
    prizeRuleTxt:
      '1. Quando a probabilidade aumentar com sucesso em 1%, você faz outro sorteio, então você poderá ganhar um grande prêmio.<br/> 2. Quando o total de moedas de ouro gastas por todos os usuários atingir um valor total, a probabilidade aumentará em 1%<br/> 3. A probabilidade de iniciar o jackpot é 0%<br/> 4. Os presentes do grande prêmio serão atualizados regularmente'
  },
  id: {
    pageTitle: 'Gashapon',
    jackPotRankTitle: 'Peringkat JackPot',
    jackPotPro: 'Probabilitas Jackpot',
    rank: 'Peringkat',
    rule: 'Aturan',
    shop: 'Toko',
    bigPrizeRule: 'Aturan Jackpot',
    poolL: 'Normal',
    poolH: 'Deluxe',
    goodsList: 'Daftar Hadiah',
    record: 'Catatan',
    ten: '10 kali',
    fifty: '50 kali',
    goods: 'Hadiah',
    count: 'Total',
    fra: 'Fragmen',
    isExchange: 'Apakah Anda yakin ingin menukar hadiah ini?',
    yes: 'Ya',
    no: 'Batal',
    rwDesc: 'Anda telah memperoleh hadiah berikut',
    congratulate: 'Selamat!',
    seeMore: 'Lihat lebih banyak',
    noMore: 'Tidak ada lagi catatan',
    exRc: 'Catatan Penukaran',
    cjRc: 'Catatan Undian',
    nw: 'Jaringan sibuk',
    noG: 'Kekurangan emas',
    noF: 'Fragmen tidak cukup',
    exSuc: 'Penukaran Berhasil',
    gf: 'Hadiah',
    ruleTxt:
      '1. Fragmen yang Anda peroleh dapat ditukarkan dengan hadiah di toko.<br/><br/> Normal<br/> 10 kali: perlu mengkonsumsi 100 koin emas<br/> 50 kali: perlu mengkonsumsi 500 koin emas<br/> Deluxe<br/> 10 kali: perlu mengkonsumsi 1000 koin emas<br/> 50 kali: perlu mengkonsumsi 5000 koin emas<br/>',
    prizeRuleTxt:
      '1. Ketika probabilitas berhasil meningkat sebesar 1%, Anda menarik lagi, maka Anda akan mendapatkan hadiah besar kemungkinan.<br/> 2. Ketika total koin emas yang dibelanjakan oleh semua pengguna mencapai nilai tertentu, probabilitas akan meningkat 1%<br/> 3. Probabilitas untuk memulai jackpot adalah 0%<br/> 4. Hadiah besar akan diperbarui secara berkala'
  },
  uz: {
    pageTitle: 'Gashapon',
    jackPotRankTitle: 'JackPot Reytingi',
    jackPotPro: 'Jackpot ehtimoli',
    rank: 'Reyting',
    rule: 'Qoidalar',
    shop: "Do'kon",
    bigPrizeRule: 'JackPot Qoidalari',
    poolL: 'Normal',
    poolH: 'Deluxe',
    goodsList: "Mukofotlar Ro'yxati",
    record: 'Yozuv',
    ten: '10 marta',
    fifty: '50 marta',
    goods: 'Mukofot',
    count: 'Jami',
    fra: 'Fragment',
    isExchange: "Siz ushbu sovg'ani almashtirmoqchimisiz?",
    yes: 'Ha',
    no: 'Bekor qilish',
    rwDesc: "Siz quyidagi sovg'alarni oldingiz",
    congratulate: 'Tabriklaymiz!',
    seeMore: "Ko'proq",
    noMore: "Boshqa yozuvlar yo'q",
    exRc: 'Almashtirish Yozuvi',
    cjRc: 'Sovrin Yozuvi',
    nw: 'Tarmoq band',
    noG: 'Oltin etishmayapti',
    noF: 'Frakmentlar etishmayapti',
    exSuc: 'Almashtirish muvaffaqiyatli',
    gf: "Sovg'a",
    ruleTxt:
      "1. Olingan fragmentlarni do'konda sovg'alar bilan almashtirishingiz mumkin.<br/><br/> Normal<br/> 10 marta: 100 oltin tanga sarflash kerak<br/> 50 marta: 500 oltin tanga sarflash kerak<br/> Deluxe<br/> 10 marta: 1000 oltin tanga sarflash kerak<br/> 50 marta: 5000 oltin tanga sarflash kerak<br/>",
    prizeRuleTxt:
      "1. Agar ehtimol 1% ga oshirilsa, yana tortishish amalga oshiriladi, shunda katta sovrin olish imkoniyati bo'ladi.<br/> 2. Agar barcha foydalanuvchilar tomonidan sarflangan oltin tangalar umumiy qiymatga yetib borsa, ehtimol 1% ga oshadi<br/> 3. Jackpot boshlanishining ehtimoli 0%<br/> 4. Katta sovrin sovg'alar muntazam yangilanadi"
  },
  ru: {
    pageTitle: 'Gashapon',
    jackPotRankTitle: 'Рейтинг JackPot',
    jackPotPro: 'Вероятность Джекпота',
    rank: 'Рейтинг',
    rule: 'Правила',
    shop: 'Магазин',
    bigPrizeRule: 'Правила Джекпота',
    poolL: 'Обычный',
    poolH: 'Делюкс',
    goodsList: 'Список Наград',
    record: 'Запись',
    ten: '10 раз',
    fifty: '50 раз',
    goods: 'Награда',
    count: 'Всего',
    fra: 'Фрагмент',
    isExchange: 'Вы уверены, что хотите обменять этот подарок?',
    yes: 'Да',
    no: 'Отмена',
    rwDesc: 'Вы получили следующие награды',
    congratulate: 'Поздравляем!',
    seeMore: 'Больше',
    noMore: 'Больше нет записей',
    exRc: 'Запись обмена',
    cjRc: 'Запись розыгрыша',
    nw: 'Сеть занята',
    noG: 'Не хватает золота',
    noF: 'Не хватает фрагментов',
    exSuc: 'Обмен успешен',
    gf: 'Подарок',
    ruleTxt:
      '1. Полученные фрагменты можно обменять на подарки в магазине.<br/><br/> Обычный<br/> 10 раз: нужно потратить 100 золотых монет<br/> 50 раз: нужно потратить 500 золотых монет<br/> Делюкс<br/> 10 раз: нужно потратить 1000 золотых монет<br/> 50 раз: нужно потратить 5000 золотых монет<br/>',
    prizeRuleTxt:
      '1. Когда вероятность успешно увеличится на 1%, вы снова сделаете розыгрыш, и возможно получите большой приз.<br/> 2. Когда общая сумма потраченных всеми пользователями золотых монет достигнет определенной суммы, вероятность увеличится на 1%<br/> 3. Вероятность начала джекпота 0%<br/> 4. Большие призы будут обновляться регулярно'
  },
  fa: {
    pageTitle: 'گاشاپون',
    jackPotRankTitle: 'رتبه‌بندی جک‌پات',
    jackPotPro: 'احتمال جک‌پات',
    rank: 'رتبه‌بندی',
    rule: 'قوانین',
    shop: 'فروشگاه',
    bigPrizeRule: 'قوانین جک‌پات',
    poolL: 'عادی',
    poolH: 'دلوکس',
    goodsList: 'فهرست جوایز',
    record: 'سوابق',
    ten: '10 بار',
    fifty: '50 بار',
    goods: 'هدیه',
    count: 'مجموع',
    fra: 'تکه',
    isExchange: 'آیا مطمئن هستید که می‌خواهید این هدیه را تعویض کنید؟',
    yes: 'بله',
    no: 'لغو',
    rwDesc: 'شما جوایز زیر را دریافت کرده‌اید',
    congratulate: 'تبریک می‌گویم!',
    seeMore: 'بیشتر',
    noMore: 'دیگر رکوردی وجود ندارد',
    exRc: 'رکورد تعویض',
    cjRc: 'رکورد قرعه‌کشی',
    nw: 'شبکه مشغول است',
    noG: 'کمبود طلا',
    noF: 'تکه‌های کافی نیست',
    exSuc: 'تعویض موفقیت‌آمیز',
    gf: 'هدیه',
    ruleTxt:
      '1. تکه‌هایی که به دست می‌آورید را می‌توانید در فروشگاه با هدیه تعویض کنید.<br/><br/> عادی<br/> 10 بار: نیاز به مصرف 100 سکه طلا<br/> 50 بار: نیاز به مصرف 500 سکه طلا<br/> دلوکس<br/> 10 بار: نیاز به مصرف 1000 سکه طلا<br/> 50 بار: نیاز به مصرف 5000 سکه طلا<br/>',
    prizeRuleTxt:
      '1. وقتی احتمال به طور موفقیت‌آمیز 1% افزایش یابد، دوباره قرعه‌کشی خواهید کرد و ممکن است یک جایزه بزرگ دریافت کنید.<br/> 2. هنگامی که مجموع سکه‌های طلای صرف‌شده توسط تمام کاربران به مقدار معینی برسد، احتمال 1% افزایش می‌یابد<br/> 3. احتمال شروع جک‌پات 0% است<br/> 4. جوایز بزرگ به طور منظم به روز می‌شوند'
  },
  ur: {
    pageTitle: 'گیشاپون',
    jackPotRankTitle: 'جیک پاٹ درجہ بندی',
    jackPotPro: 'جیک پاٹ<br/>امکان',
    rank: 'درجہ بندی',
    rule: 'قواعد',
    shop: 'دکان',
    bigPrizeRule: 'جیک پاٹ قواعد',
    poolL: 'عام',
    poolH: 'ڈیلکس',
    goodsList: 'انعامات کی فہرست',
    record: 'ریکارڈ',
    ten: '10 بار',
    fifty: '50 بار',
    goods: 'انعام',
    count: 'کل',
    fra: 'ٹکڑا',
    isExchange: 'کیا آپ واقعی یہ تحفہ تبدیل کرنا چاہتے ہیں؟',
    yes: 'ہاں',
    no: 'منسوخ',
    rwDesc: 'آپ کو مندرجہ ذیل انعامات ملے ہیں',
    congratulate: 'مبارک ہو!',
    seeMore: 'مزید',
    noMore: 'مزید ریکارڈز نہیں',
    exRc: 'تبادلے کا ریکارڈ',
    cjRc: 'ڈرا ریکارڈ',
    nw: 'نیٹ ورک مصروف ہے',
    noG: 'سونے کی کمی',
    noF: 'ٹکڑے ناکافی',
    exSuc: 'تبادلہ کامیاب',
    gf: 'تحفہ',
    ruleTxt:
      '1. آپ کو ملنے والے ٹکڑوں کو دکان میں تحفوں کے بدلے استعمال کیا جا سکتا ہے۔<br/><br/>عام<br/>10 بار: 100 سونے کے سکے درکار<br/>50 بار: 500 سونے کے سکے درکار<br/>ڈیلکس<br/>10 بار: 1000 سونے کے سکے درکار<br/>50 بار: 5000 سونے کے سکے درکار',
    prizeRuleTxt:
      '1. جب امکان 1% بڑھ جائے تو دوبارہ ڈرا کرنے پر آپ کو بڑا انعام مل سکتا ہے۔<br/>2. جب تمام صارفین کے خرچ کردہ سونے کے سکے ایک مخصوص حد تک پہنچ جائیں تو امکان 1% بڑھ جائے گا<br/>3. جیک پاٹ کا شروع کا امکان 0% ہے<br/>4. بڑے انعامات کے تحائف باقاعدگی سے اپ ڈیٹ کیے جائیں گے'
  }
}



// WEBPACK FOOTER //
// src/pages/app/gashapon/lang.js